import { render, staticRenderFns } from "./ApplicationRefixationHandler.vue?vue&type=template&id=1c5007b8&scoped=true&"
import script from "./ApplicationRefixationHandler.vue?vue&type=script&lang=js&"
export * from "./ApplicationRefixationHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5007b8",
  null
  
)

export default component.exports